import { useState, useEffect } from "react";
import { subirDatos, bajarDatos } from "./syncSupabase";

const TAG_STYLE = {
  'AUDITORÍA':         { color:'#3ECF8E', bg:'rgba(62,207,142,.12)' },
  'CERTIFICACIÓN':     { color:'#2A7FFF', bg:'rgba(42,127,255,.14)' },
  'ACCIÓN CORRECTIVA': { color:'#b3b6ee', bg:'rgba(107,111,214,.16)' },
  'RACHA':             { color:'#8fa8ff', bg:'rgba(28,63,170,.22)' },
  'CUMPLEAÑOS':        { color:'#f9a8d4', bg:'rgba(249,168,212,.14)' },
  'COMUNICADO':        { color:'#EDEFF7', bg:'rgba(232,233,246,.10)' },
  'MANUAL':            { color:'#EDEFF7', bg:'rgba(232,233,246,.10)' },
};
const REACCIONES = [['like','👍'],['love','😍'],['clap','👏'],['fire','🔥']];

function leerPublicados() {
  try {
    return JSON.parse(localStorage.getItem('alqos_news') || '[]')
      .filter(n => n.estado === 'publicado')
      .sort((a,b) => new Date(b.fechaPublicacion) - new Date(a.fechaPublicacion));
  } catch { return []; }
}

function tiempoRelativo(fechaISO) {
  if (!fechaISO) return '';
  const dias = Math.floor((Date.now() - new Date(fechaISO).getTime()) / 86400000);
  if (dias <= 0) return 'hoy';
  if (dias === 1) return 'hace 1 día';
  if (dias < 14) return `hace ${dias} días`;
  const semanas = Math.floor(dias / 7);
  if (semanas < 5) return semanas === 1 ? 'hace 1 semana' : `hace ${semanas} semanas`;
  const meses = Math.floor(dias / 30);
  return meses <= 1 ? 'hace 1 mes' : `hace ${meses} meses`;
}

// ─── PILL DE NAV — badge con cantidad de publicados, sin desplazar el resto del header ─
export function AlqosNewsPill({ onClick }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const leer = () => setCount(leerPublicados().length);
    leer();
    window.addEventListener('supabase-sync-complete', leer);
    window.addEventListener('alqos-news-actualizado', leer);
    return () => {
      window.removeEventListener('supabase-sync-complete', leer);
      window.removeEventListener('alqos-news-actualizado', leer);
    };
  }, []);
  return (
    <div onClick={onClick} title="ALQOS News"
      style={{ position:"absolute", left:"50%", top:"50%", transform:"translate(-50%, -50%)",
        display:"flex", alignItems:"center", gap:"8px", background:"rgba(255,255,255,0.08)",
        border:"1px solid rgba(255,255,255,0.16)", padding:"7px 14px 7px 10px", borderRadius:"999px",
        cursor:"pointer", fontSize:"12.5px", color:"rgba(255,255,255,0.85)", userSelect:"none",
        transition:"border-color 0.15s, background 0.15s" }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = "#2A7FFF"; e.currentTarget.style.background = "rgba(42,127,255,0.14)"; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.16)"; e.currentTarget.style.background = "rgba(255,255,255,0.08)"; }}>
      <span style={{ width:"7px", height:"7px", borderRadius:"50%", background:"#2A7FFF", boxShadow:"0 0 0 3px rgba(42,127,255,0.18)" }}/>
      <span>📰 ALQOS <b style={{ color:"white", fontWeight:700 }}>News</b></span>
      {count > 0 && <span style={{ background:"#2A7FFF", color:"white", fontWeight:700, fontSize:"10.5px", padding:"1px 7px", borderRadius:"999px" }}>{count}</span>}
    </div>
  );
}

// ─── PANTALLA — feed público, visible para cualquier usuario logueado ─
export default function AlqosNews({ onVolver, usuario }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const cargar = async () => {
      await bajarDatos('alqos_news');
      setItems(leerPublicados());
    };
    cargar();
    const onSync = () => setItems(leerPublicados());
    window.addEventListener('supabase-sync-complete', onSync);
    return () => window.removeEventListener('supabase-sync-complete', onSync);
  }, []);

  const guardarLista = (lista) => {
    setItems(lista.filter(n => n.estado === 'publicado').sort((a,b) => new Date(b.fechaPublicacion) - new Date(a.fechaPublicacion)));
    localStorage.setItem('alqos_news', JSON.stringify(lista));
    subirDatos('alqos_news');
    window.dispatchEvent(new Event('alqos-news-actualizado'));
  };

  const toggleReaccion = (item, tipo) => {
    const uid = String(usuario?.id ?? '');
    if (!uid) return;
    const reaccionesActuales = { ...(item.reacciones || {}) };
    if (reaccionesActuales[uid] === tipo) delete reaccionesActuales[uid];
    else reaccionesActuales[uid] = tipo;
    const actualizado = { ...item, reacciones: reaccionesActuales };
    let lista;
    try { lista = JSON.parse(localStorage.getItem('alqos_news') || '[]'); } catch { lista = items; }
    lista = lista.map(i => i.id === item.id ? actualizado : i);
    guardarLista(lista);
  };

  const contarReacciones = (item, tipo) => Object.values(item.reacciones || {}).filter(t => t === tipo).length;
  const miReaccion = (item) => item.reacciones?.[String(usuario?.id ?? '')];

  return (
    <div style={{ minHeight:"100vh", background:"radial-gradient(1200px 600px at 20% -10%, #22264a 0%, #2B2F36 55%)", padding:"32px 24px 60px", fontFamily:"Inter, sans-serif" }}>
      <div style={{ maxWidth:"920px", margin:"0 auto" }}>

        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"20px" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
            <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:"8px", padding:"6px 12px", fontSize:"12px", cursor:"pointer", color:"#9BA3B4" }}>← Menú</button>
            <div>
              <h1 style={{ fontSize:"19px", fontWeight:"700", color:"#EDEFF7", margin:0 }}>📰 ALQOS News</h1>
              <p style={{ fontSize:"12px", color:"#9BA3B4", margin:0 }}>Novedades curadas por Calidad — auditorías, certificaciones, logros del equipo</p>
            </div>
          </div>
        </div>

        <div style={{ background:"linear-gradient(180deg, #20242c 0%, #262b34 100%)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:"18px", padding:"20px 20px 8px", boxShadow:"0 20px 50px -20px rgba(0,0,0,.6)" }}>
          {items.length === 0 ? (
            <div style={{ textAlign:"center", padding:"60px 20px", color:"#9BA3B4" }}>
              <div style={{ fontSize:"36px", marginBottom:"10px" }}>📰</div>
              <div style={{ fontSize:"13px" }}>Todavía no hay novedades publicadas.</div>
            </div>
          ) : items.map(item => {
            const tagStyle = TAG_STYLE[item.tag] || TAG_STYLE.MANUAL;
            return (
              <div key={item.id} style={{ display:"flex", gap:"14px", padding:"16px 4px", borderTop:"1px solid rgba(255,255,255,0.07)" }}>
                <div style={{ flex:"0 0 auto", width:"38px", height:"38px", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"17px", background:tagStyle.bg, color:tagStyle.color }}>
                  {item.icono || '📣'}
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", alignItems:"baseline", justifyContent:"space-between", gap:"10px" }}>
                    <div style={{ fontSize:"13.5px", fontWeight:"600", color:"#EDEFF7" }}>{item.titulo}</div>
                    <div style={{ fontSize:"11px", color:"#9BA3B4", whiteSpace:"nowrap" }}>{tiempoRelativo(item.fechaPublicacion)}</div>
                  </div>
                  {item.descripcion && <div style={{ fontSize:"12.5px", color:"#9BA3B4", marginTop:"3px", lineHeight:"1.5" }}>{item.descripcion}</div>}
                  {item.tag && <span style={{ display:"inline-block", marginTop:"8px", fontSize:"10.5px", fontWeight:"700", letterSpacing:".3px", padding:"3px 8px", borderRadius:"6px", background:tagStyle.bg, color:tagStyle.color }}>{item.tag}</span>}
                  <div style={{ display:"flex", gap:"8px", marginTop:"10px", flexWrap:"wrap" }}>
                    {REACCIONES.map(([tipo, emoji]) => {
                      const activa = miReaccion(item) === tipo;
                      const n = contarReacciones(item, tipo);
                      return (
                        <div key={tipo} onClick={() => toggleReaccion(item, tipo)}
                          style={{ display:"flex", alignItems:"center", gap:"5px", fontSize:"12px", color: activa ? "#EDEFF7" : "#9BA3B4",
                            background: activa ? "rgba(42,127,255,0.14)" : "rgba(255,255,255,.03)",
                            border:`1px solid ${activa ? "#2A7FFF" : "rgba(255,255,255,0.07)"}`,
                            padding:"4px 9px", borderRadius:"999px", cursor:"pointer", userSelect:"none" }}>
                          {emoji} {n > 0 ? n : ''}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ textAlign:"center", fontSize:"11px", color:"#9BA3B4", marginTop:"16px" }}>
          Solo Administrador / Calidad puede publicar acá — nunca automático.
        </div>
      </div>
    </div>
  );
}
